import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService
  ) { }

  getAllReports(): Promise<any[]> {
    let user = this.authenticationService.getCurrentUser();
    let path = `${environment.adminApiUrl}report`;
  
    // this.userCVR = user.cvr;
    return (
      this.http
        .get<any>(path)
        .pipe(catchError(this.handleError))
        .toPromise()
        .then((res) => res)
        .then((data) => {
          return data;
        })
        .catch((ex) => {
          console.error('Error fetching report list', ex);
        })
    );
  }
  
  getReport(uuid: string): Observable<any> {
    let user = this.authenticationService.getCurrentUser();
    let path = `${environment.adminApiUrl}report/${uuid}`;
    let headers = new HttpHeaders({ 'responseType': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const requestOptions: Object = {
      /* other options here */
      responseType: 'blob'
    }
    return (
      this.http.get<any>(path, requestOptions)
    )
  }

  private handleError(error: HttpErrorResponse) {
    console.log(error.error);
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `,
        error.error
      );
    }
    // Return an observable with a user-facing error message.
    return throwError('Something bad happened; please try again later.');
  }
  
}
